module.exports = __webpack_public_path__ + "media/man.8d31f443.mp4";